// extracted by mini-css-extract-plugin
module.exports = {"secBottom":"__076b8BxL","section":"C9Hb_XRm","wrap":"PcoctaGB","title":"jurrTJZ_","canClick":"Ffw0zt5u"};